import { Link } from '../src/Link';
export { Link };
export type LinkProps = Parameters<typeof Link>[0];
